<template>
    <modal v-model="show" max-width="900" :has-padding="false">
        <app-ip-firewall-modal
            :dataActivatorText="$t('message.overview.message.registerIp')"
        ></app-ip-firewall-modal>

        <div class="wrapper" :key="deviceId">
            <div class="header">
                <button
                    class="btn btn-primary btn-extra-round"
                    slot="activator"
                    @click="create()"
                >
                    {{ $t("message.generics.message.register") }}
                </button>

                <div class="search-wrapper">
                    <app-search @submit="search" />
                </div>
            </div>

            <v-data-table
                :headers="headers"
                :items="list"
                :total-items="30"
                :loading="loading"
                :pagination.sync="sync"
                :hide-actions="true"
                :must-sort="true"
                :no-data-text="$t('message.generics.message.noData')"
                :no-results-text="$t('message.generics.message.noData')"
                sort-icon="mdi-chevron-down"
            >
                <v-progress-linear
                    slot="progress"
                    :color="providerColor"
                    indeterminate
                />

                <template slot="items" slot-scope="props">
                    <app-ip-firewall-table-item
                        :data-item="props.item"
                    ></app-ip-firewall-table-item>
                </template>
            </v-data-table>

            <v-pagination
                v-if="totalPages"
                v-model="sync.page"
                color="primary"
                :length="totalPages"
                @input="setPage"
            ></v-pagination>
        </div>
    </modal>
</template>

<script>
import AppIpFirewallModal from "./components/ip-firewall-modal/IpFirewallModal";
import EventBus from "@packages/event-bus";
import paginatedTable from "@mixins/paginated-table";
import AppIpFirewallTableItem from "./components/IpFirewallTableItem";
import AppSearch from "@components/Search";
import Modal from "@/components/generic/Modal";
import provider from "@mixins/provider";

export default {
    components: {
        AppIpFirewallModal,
        AppIpFirewallTableItem,
        AppSearch,
        Modal,
    },

    data() {
        return {
            show: false,
            deviceId: null,
            entity: "ipfirewall",
        };
    },

    destroyed() {
        this.$store.commit("IPFIREWALL_RESET_FILTERS");
    },

    mixins: [paginatedTable, provider],

    computed: {
        filters() {
            return this.$store.state.ipfirewall.filters;
        },
        headers() {
            return [
                { text: this.$t("message.generics.message.ip"), value: "ip" },
                {
                    text: this.$t("message.generics.message.operation"),
                    value: "operacao",
                },
                {
                    text: this.$t("message.overview.message.observations"),
                    value: "observacao",
                },
            ];
        },
    },
    methods: {
        search(search) {
            EventBus.$emit("GO_TO_FIRST_PAGE");
            this.$store.commit("IPFIREWALL_SET_FILTER", {
                key: "search",
                value: search,
            });
        },
        create() {
            EventBus.$emit("CREATE_IPFIREWALL");
        },
        editIpsFirewall() {
            this.$store.commit("IPFIREWALL_SET_FILTER", {
                key: "search",
                value: "",
            });
            this.load();
            this.show = true;
        },
    },
    mounted() {
        EventBus.$on("EDIT_IPSFIREWALL", this.editIpsFirewall);
        EventBus.$on("LOAD_IPFIREWALL", this.load);
    },
    beforeDestroy() {
        EventBus.$off("EDIT_IPSFIREWALL", this.editIpsFirewall);
        EventBus.$off("LOAD_IPFIREWALL", this.load);
    },
};
</script>

<style lang="scss" scoped>
.wrapper {
    padding: 20px;
}
.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
</style>
